/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import BetForm from "./sub_components/betForm";
import * as stringParser from "../util/string.util";
import Currency from "./sub_components/currency";
import Volume from "./sub_components/volume";
import { calculateFancyMktExpouser } from "../util/expouser.util";
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import { DemoBetDelay } from "../configs/casinoShowList";
export default class fancybook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      runner_name: "",
      bid_at: "",
      bid_amount: 0,
      bid_line: "",
      book: {},
      market: {},
      selectionId: "",
      expo: {},
      infoHide: true,
      width: document.documentElement.clientWidth,
      mktMsg: ''
    };
    this.onChange = this.onChange.bind(this);
    this.changeBid = this.changeBid.bind(this);
  }
  selectBid(runner_name, bid_at, market_id, bid_for, team, bid_line) {
    localStorage.setItem(
      "betForm",
      JSON.stringify({
        runner_name: runner_name,
        bid_at: bid_at,
        bid_amount: 0,
        selectionId: team.id.toString(),
        bid_line: bid_line,
      })
    );
    this.setState(
      {
        runner_name: runner_name,
        bid_at: bid_at,
        bid_amount: 0,
        selectionId: team.id.toString(),
        bid_line: bid_line,
      },
      () => {
        this.props.betForm(market_id, bid_for, "clicked");
      }
    );
  }
  changeBid(val) {
    this.setState({ bid_amount: val });
  }
  updateExpo(exp) {
    this.setState({ expo: exp });
  }
  onChange(e) {
    this.changeBid(e.target.value);
  }
  thexInputClick(val) {
    let cur_amount = this.state.bid_amount.toString();
    let new_amount = "";
    if (val !== "back") {
      new_amount = cur_amount + val.toString();
    } else {
      new_amount = cur_amount.substring(0, cur_amount.length - 1);
    }
    this.changeBid(new_amount);
  }
  componentWillUnmount() {
    if (!!this.props.socket) {
      this.props.socket.off("market_room")
    }
  }
  componentDidMount() {
    const socket = this.props.socket;
    this.setState({ market: this.props.market, book: {} }, () => {
      this.setState({
        book: !!this.props.feedBooks[this.props.market.marketId]
          ? this.props.feedBooks[this.props.market.marketId]
          : !!this.props.market.metadata && !!this.props.market.metadata.book
            ? this.props.market.metadata.book
            : {},
      });
      if (
        this.props.selected_market === this.props.market.marketId &&
        (this.state.book.sportingEvent || this.state.book.status !== "OPEN")
      ) {
        this.props.betForm("", "");
      }
    });
    if (
      !this.props.market.metadata ||
      !this.props.market.metadata.book ||
      this.props.market.metadata.book.status === "CLOSED" ||
      this.props.market.metadata.book.status === "INACTIVE"
    ) {
      return false;
    }
    let stream = "";
    const accData = JSON.parse(localStorage.getItem("accountData"));
    if (!!accData && Object.keys(accData).length > 0) {
      if (
        this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1
      ) {
        if (
          this.props.subscriptions.market_room.indexOf(
            this.props.market.marketId
          ) === -1
        ) {
          socket.emit("market_room", this.props.market.marketId);
          this.props.subscribe("market_room", this.props.market.marketId);
          this.props.updateSubscribedMarkets(this.props.market.marketId);
        }
      }
      socket.on("market_room", (data) => {
        // let objData = JSON.parse(data)
        // if (!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId === this.props.market.marketId) {
        //   this.setState({ mktMsg: objData.payload.message })
        // } else 
        if (stream !== data) {
          stream = data;
          let newBook = null;
          try {
            newBook = stringParser.deSrlz(data);
          } catch {
            let baseData = {
              marketId: this.props.market.marketId,
              status: "OPEN",
              runners: [],
            };
            this.state.market.runners.forEach((rnr) => {
              let data = {
                selectionId: rnr.id.toString(),
                status: "ACTIVE",
                back: [
                  { price: "0", size: "0", line: "0" },
                  { price: "0", size: "0", line: "0" },
                  { price: "0", size: "0", line: "0" },
                ],
                lay: [
                  { price: "0", size: "0", line: "0" },
                  { price: "0", size: "0", line: "0" },
                  { price: "0", size: "0", line: "0" },
                ],
              };
              baseData.runners.push(data);
            });
            newBook = baseData;
          }
          if (this.props.market.marketId === newBook.marketId) {
            this.props.updateBook(this.props.market.marketId, newBook);
            let curBook = this.state.book;
            if (!curBook || !curBook.runners) {
              this.setState({ book: newBook });
              return false;
            }
            curBook.runners.forEach((rn, i) => {
              let nrn = newBook.runners[i];
              if (!nrn) {
                nrn = {};
                nrn.back = [
                  { price: "", size: "" },
                  { price: "", size: "" },
                  { price: "", size: "" },
                ];
                nrn.lay = [
                  { price: "", size: "" },
                  { price: "", size: "" },
                  { price: "", size: "" },
                ];
              }
              if (!nrn.back || nrn.back.length === 0) {
                newBook.back = [
                  { price: "", size: "" },
                  { price: "", size: "" },
                  { price: "", size: "" },
                ];
              }
              rn.back.forEach((bk, j) => {
                if (!!nrn.back[j]) {
                  if (bk.price !== nrn.back[j].price) {
                    nrn.back[j].has_blink = true;
                  } else {
                    nrn.back[j].has_blink = false;
                  }
                }
              });
              if (!nrn.lay || nrn.lay.length === 0) {
                newBook.back = [
                  { price: "", size: "" },
                  { price: "", size: "" },
                  { price: "", size: "" },
                ];
              }
              if (!!rn.lay && rn.lay.length > 0) {
                rn.lay.forEach((ly, k) => {
                  if (!!nrn.lay[k]) {
                    if (ly.price !== nrn.lay[k].price) {
                      nrn.lay[k].has_blink = true;
                    } else {
                      nrn.lay[k].has_blink = false;
                    }
                  }
                });
              }
              newBook.runners[i] = nrn;
            });
            this.setState({ book: newBook }, () => {
              if (
                this.props.selected_market === this.props.market.marketId &&
                this.props.market.bettingType === "BOOKMAKER" &&
                (this.state.book.sportingEvent ||
                  this.state.book.status !== "OPEN")
              ) {
                this.props.betForm("", "");
              }
              setTimeout(() => {
                curBook.runners.forEach((rn, i) => {
                  let nrn = newBook.runners[i];
                  rn.back.forEach((bk, j) => {
                    if (!!nrn.back[j]) {
                      nrn.back[j].has_blink = false;
                    }
                  });
                  rn.lay.forEach((ly, k) => {
                    if (!!nrn.lay[k]) {
                      nrn.lay[k].has_blink = false;
                    }
                  });
                  newBook.runners[i] = nrn;
                });
                this.setState({ book: newBook });
              }, 500);
            });
          }
        }
      });
      setInterval(() => {
        socket.on("market_room", (data) => {
          // let objData = JSON.parse(data)
          // if (!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId === this.props.market.marketId) {
          //   this.setState({ mktMsg: objData.payload.message })
          // } else 
          if (stream !== data) {
            stream = data;
            let newBook = null;
            try {
              newBook = stringParser.deSrlz(data);
            } catch {
              let baseData = {
                marketId: this.props.market.marketId,
                status: "OPEN",
                runners: [],
              };
              this.state.market.runners.forEach((rnr) => {
                let data = {
                  selectionId: rnr.id.toString(),
                  status: "ACTIVE",
                  back: [
                    { price: "0", size: "0", line: "0" },
                    { price: "0", size: "0", line: "0" },
                    { price: "0", size: "0", line: "0" },
                  ],
                  lay: [
                    { price: "0", size: "0", line: "0" },
                    { price: "0", size: "0", line: "0" },
                    { price: "0", size: "0", line: "0" },
                  ],
                };
                baseData.runners.push(data);
              });
              newBook = baseData;
            }
            if (this.props.market.marketId === newBook.marketId) {
              this.props.updateBook(this.props.market.marketId, newBook);
              let curBook = this.state.book;
              if (!curBook || !curBook.runners) {
                this.setState({ book: newBook });
                return false;
              }
              curBook.runners.forEach((rn, i) => {
                let nrn = newBook.runners[i];
                if (!nrn) {
                  nrn = {};
                  nrn.back = [
                    { price: "", size: "" },
                    { price: "", size: "" },
                    { price: "", size: "" },
                  ];
                  nrn.lay = [
                    { price: "", size: "" },
                    { price: "", size: "" },
                    { price: "", size: "" },
                  ];
                }
                if (!nrn.back || nrn.back.length === 0) {
                  newBook.back = [
                    { price: "", size: "" },
                    { price: "", size: "" },
                    { price: "", size: "" },
                  ];
                }
                rn.back.forEach((bk, j) => {
                  if (!!nrn.back[j]) {
                    if (bk.price !== nrn.back[j].price) {
                      nrn.back[j].has_blink = true;
                    } else {
                      nrn.back[j].has_blink = false;
                    }
                  }
                });
                if (!nrn.lay || nrn.lay.length === 0) {
                  newBook.back = [
                    { price: "", size: "" },
                    { price: "", size: "" },
                    { price: "", size: "" },
                  ];
                }
                if (!!rn.lay && rn.lay.length > 0) {
                  rn.lay.forEach((ly, k) => {
                    if (!!nrn.lay[k]) {
                      if (ly.price !== nrn.lay[k].price) {
                        nrn.lay[k].has_blink = true;
                      } else {
                        nrn.lay[k].has_blink = false;
                      }
                    }
                  });
                }
                newBook.runners[i] = nrn;
              });
              this.setState({ book: newBook }, () => {
                if (
                  this.props.selected_market === this.props.market.marketId &&
                  this.props.market.bettingType === "BOOKMAKER" &&
                  (this.state.book.sportingEvent ||
                    this.state.book.status !== "OPEN")
                ) {
                  this.props.betForm("", "");
                }
                setTimeout(() => {
                  curBook.runners.forEach((rn, i) => {
                    let nrn = newBook.runners[i];
                    rn.back.forEach((bk, j) => {
                      if (!!nrn.back[j]) {
                        nrn.back[j].has_blink = false;
                      }
                    });
                    rn.lay.forEach((ly, k) => {
                      if (!!nrn.lay[k]) {
                        nrn.lay[k].has_blink = false;
                      }
                    });
                    newBook.runners[i] = nrn;
                  });
                  this.setState({ book: newBook });
                }, 500);
              });
            }
          }
        });
      }, 15000);
    }
    // socket.on('disconnect', () => {
    //     socket.emit('market_room', this.props.market.marketId)
    // })
  }
  componentWillReceiveProps() {
    if (this.props.isEventUpdate) {
      this.setState({ market: this.props.market, book: {} }, () => {
        // this.props.socket.emit('market_room', this.props.market.marketId)
        // let book = {}
        // if (!!this.props.feedBooks[this.props.market.marketId] && !!this.props.market.metadata && !!this.props.market.metadata.book) {
        //     book = !!this.props.feedBooks[this.props.market.marketId].updateTime > this.props.market.metadata.book.updateTime ? this.props.feedBooks[this.props.market.marketId] : this.props.market.metadata.book
        // } else if (!!this.props.market.metadata && !!this.props.market.metadata.book) {
        //     book = this.props.market.metadata.book
        // }
        // this.setState({ book: { ...book } })
        const socket = this.props.socket;
        this.setState({ market: this.props.market, book: {} }, () => {
          this.setState({
            book: !!this.props.feedBooks[this.props.market.marketId]
              ? this.props.feedBooks[this.props.market.marketId]
              : !!this.props.market.metadata &&
                !!this.props.market.metadata.book
                ? this.props.market.metadata.book
                : {},
          });
          if (
            this.props.selected_market === this.props.market.marketId &&
            (this.state.book.sportingEvent || this.state.book.status !== "OPEN")
          ) {
            this.props.betForm("", "");
          }
        });
        if (
          !this.props.market.metadata ||
          !this.props.market.metadata.book ||
          this.props.market.metadata.book.status === "CLOSED" ||
          this.props.market.metadata.book.status === "INACTIVE"
        ) {
          return false;
        }
        let stream = "";
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if (!!accData && Object.keys(accData).length > 0) {
          if (
            this.props.subscribedMarkets.indexOf(this.props.market.marketId) ===
            -1
          ) {
            if (
              this.props.subscriptions.market_room.indexOf(
                this.props.market.marketId
              ) === -1
            ) {
              socket.emit("market_room", this.props.market.marketId);
              this.props.subscribe("market_room", this.props.market.marketId);
              this.props.updateSubscribedMarkets(this.props.market.marketId);
            }
          }
          let stream = "";
          socket.on("message_room", data => {
            let objData = JSON.parse(data)
            if (!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId === this.props.market.marketId) {
              this.setState({ mktMsg: objData.payload.message })
              if(this.props.updateMktMsg){
                this.props.updateMktMsg(objData.payload)
               }
            }
          });
          socket.on("market_room", (data) => {
            if (stream !== data) {
              stream = data;
              let newBook = null;
              try {
                newBook = stringParser.deSrlz(data);
              } catch {
                let baseData = {
                  marketId: this.props.market.marketId,
                  status: "OPEN",
                  runners: [],
                };
                this.state.market.runners.forEach((rnr) => {
                  let data = {
                    selectionId: rnr.id.toString(),
                    status: "ACTIVE",
                    back: [
                      { price: "0", size: "0", line: "0" },
                      { price: "0", size: "0", line: "0" },
                      { price: "0", size: "0", line: "0" },
                    ],
                    lay: [
                      { price: "0", size: "0", line: "0" },
                      { price: "0", size: "0", line: "0" },
                      { price: "0", size: "0", line: "0" },
                    ],
                  };
                  baseData.runners.push(data);
                });
                newBook = baseData;
              }
              if (this.props.market.marketId === newBook.marketId) {
                this.props.updateBook(this.props.market.marketId, newBook);
                let curBook = this.state.book;
                if (!curBook || !curBook.runners) {
                  this.setState({ book: newBook });
                  return false;
                }
                curBook.runners.forEach((rn, i) => {
                  let nrn = newBook.runners[i];
                  if (!nrn) {
                    nrn = {};
                    nrn.back = [
                      { price: "", size: "" },
                      { price: "", size: "" },
                      { price: "", size: "" },
                    ];
                    nrn.lay = [
                      { price: "", size: "" },
                      { price: "", size: "" },
                      { price: "", size: "" },
                    ];
                  }
                  if (!nrn.back || nrn.back.length === 0) {
                    newBook.back = [
                      { price: "", size: "" },
                      { price: "", size: "" },
                      { price: "", size: "" },
                    ];
                  }
                  rn.back.forEach((bk, j) => {
                    if (!!nrn.back[j]) {
                      if (bk.price !== nrn.back[j].price) {
                        nrn.back[j].has_blink = true;
                      } else {
                        nrn.back[j].has_blink = false;
                      }
                    }
                  });
                  if (!nrn.lay || nrn.lay.length === 0) {
                    newBook.back = [
                      { price: "", size: "" },
                      { price: "", size: "" },
                      { price: "", size: "" },
                    ];
                  }
                  if (!!rn.lay && rn.lay.length > 0) {
                    rn.lay.forEach((ly, k) => {
                      if (!!nrn.lay[k]) {
                        if (ly.price !== nrn.lay[k].price) {
                          nrn.lay[k].has_blink = true;
                        } else {
                          nrn.lay[k].has_blink = false;
                        }
                      }
                    });
                  }
                  newBook.runners[i] = nrn;
                });
                this.setState({ book: newBook }, () => {
                  if (
                    this.props.selected_market === this.props.market.marketId &&
                    this.props.market.bettingType === "BOOKMAKER" &&
                    (this.state.book.sportingEvent ||
                      this.state.book.status !== "OPEN")
                  ) {
                    this.props.betForm("", "");
                  }
                  setTimeout(() => {
                    curBook.runners.forEach((rn, i) => {
                      let nrn = newBook.runners[i];
                      rn.back.forEach((bk, j) => {
                        if (!!nrn.back[j]) {
                          nrn.back[j].has_blink = false;
                        }
                      });
                      rn.lay.forEach((ly, k) => {
                        if (!!nrn.lay[k]) {
                          nrn.lay[k].has_blink = false;
                        }
                      });
                      newBook.runners[i] = nrn;
                    });
                    this.setState({ book: newBook });
                  }, 500);
                });
              }
            }
          });
        }
      });
    }
  }
  userPropertyUpdate() {
    let market = this.props.market;
    let userMktCondition = localStorage.getItem("accountData");
    userMktCondition = JSON.parse(userMktCondition);
    if (market.marketCondition.maxBet === 0) {
      market.maxBet = !!userMktCondition ? userMktCondition.maxBet : 0;
    } else if (!userMktCondition || userMktCondition.maxBet === 0) {
      market.maxBet = !!market.marketCondition
        ? market.marketCondition.maxBet
        : 0;
    } else {
      market.maxBet = market.marketCondition.maxBet;
    }
    market.betDelay =
      !!market.marketCondition && !!userMktCondition
        ? Math.max(market.marketCondition.betDelay, userMktCondition.betDelay)
        : 0;
    return market;
  }
  addBetFn(dt, mkt){
    dt.marketId = mkt.marketId; 
    dt.selectionId = this.state.selectionId; 

    const prfdt = JSON.parse(localStorage.getItem('profData'));
    if(prfdt?.role === 'DemoClient'){
        this.props.togglebetLoader()    
        setTimeout(() => {    
          let line = dt.line
          this.state.book.runners.forEach((itm)=>{
              if(itm.selectionId === dt.selectionId){
                line = itm[dt.bet_for][0].line;
              }
          })
          dt.market.metadata.book.runners = this.state.book.runners;
          dt.line = line;
          this.props.addBet(dt)
        }, DemoBetDelay);
    } else {
        this.props.addBet(dt)
    }
}
  render() {
    const accData = JSON.parse(localStorage.getItem("accountData"));
    let market = this.userPropertyUpdate();
    let book = this.state.book;
    let runners =
      !!this.state.book &&
        this.state.book !== {} &&
        !!this.state.book.runners &&
        this.state.book.runners.length > 0
        ? this.state.book.runners
        : null;
    if (!!runners) {
      runners = runners.sort(function (a, b) {
        return a.selectionId - b.selectionId;
      });
    }
    let mktBets = [];
    if (this.props.curBets) {
      mktBets = this.props.curBets.filter((bet, i) => {
        return bet.marketId === this.props.market.marketId;
      });
    }
    let mktLineExpo = {};
    let marketExpo = 0;
    if (mktBets.length > 0) {
      let expo = calculateFancyMktExpouser(market, mktBets);
      marketExpo = expo.expo;
      mktLineExpo = expo.lineExpos;
    }
    let runnerCount = 0;
    if (!!book.runners && book.runners.length > 1) {
      let runnerList = book.runners.filter((rnr) => {
        return rnr.status !== "REMOVED" && rnr.status !== "SUSPENDED";
      });
      runnerCount = runnerList.length;
    }
    // let multiplayFector = market.marketCondition.volume
    let currencyConversion = (!!accData && Object.keys(accData).length > 0) ? JSON.parse(localStorage.getItem('profData')).currencyConversion : 1;
    return (
      <>
        {!!book &&
          book !== {} &&
          book.status !== "CLOSED" &&
          book.status !== "INACTIVE" && (
            <>
              <tr className="brblumobile d-none">
                <td colSpan="3">
                  <div className="w-100">
                    {(!!accData && Object.keys(accData).length > 0) &&
                      <a
                        onClick={(e) => {
                          e.stopPropagation();
                          this.props.toggleMultiMarket(market.marketId);
                        }}
                        className={
                          this.props.pinnedEvents.indexOf(market.marketId) > -1
                            ? "add-pin-d select-pin-d mr-1"
                            : "add-pin-d mr-1"
                        }
                        style={{ cursor: "pointer" }}
                        title="Add to Multi Markets"
                      ></a>
                    }
                    <span
                      className="in-play-title-m"
                      onClick={() => {
                        if (mktBets.length > 0) {
                          this.props.showExpo(mktLineExpo, market.marketName);
                        }
                      }}
                    >
                      {market.marketName}{" "}
                    </span>
                    <a
                      onClick={() => {
                        this.setState({ infoHide: false });
                      }}
                      className="dhide float-right"
                    >
                      <i className="fa fa-info-circle" aria-hidden="true"></i>
                    </a>
                  </div>
                  {/* {!this.state.infoHide && <div className="mobile-show" style={{ background: "#ccdddd", padding: "5px", borderRadius: "5px", position: "absolute", width: "94%", zIndex: "1" }}>
                                    <span className="d-block "> Max:<span>{market.maxBet}</span> |  Max Profit:<span>{market.marketCondition.maxProfit}</span><span onClick={() => { this.setState({ infoHide: true }) }} style={{ marginRight: 5, cursor: "pointer" }} className="float-right">X</span></span>
                                </div>} */}
                </td>
              </tr>
              <tr>
                <td
                  className={runnerCount > 1 ? "fancyw-50 v-align px-1" : "fancyw-50 px-1"} >
                  <div className="in-play-title ">
                    <div>
                      {(!!accData && Object.keys(accData).length > 0) &&
                        <a onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(market.marketId); }}
                          className={this.props.pinnedEvents.indexOf(market.marketId) > -1 ? "add-pin-d select-pin-d mr-1" : "add-pin-d mr-1"} style={{ cursor: "pointer" }} title="Add to Multi Markets" >
                        </a>
                      }
                      {this.state.width > 991 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 768 &&
                        market.marketName.length < 52 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 575 &&
                        market.marketName.length < 45 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 500 &&
                        market.marketName.length < 37 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 469 &&
                        market.marketName.length < 37 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 414 &&
                        market.marketName.length < 37 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 390 &&
                        market.marketName.length < 25 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 375 &&
                        market.marketName.length < 35 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 374 &&
                        market.marketName.length < 35 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : this.state.width >= 320 &&
                        market.marketName.length < 25 ? (
                        <span
                          className="marketnamemobile"
                          title={market.marketName}
                          onClick={() => {
                            if (mktBets.length > 0) {
                              this.props.showExpo(
                                mktLineExpo,
                                market.marketName
                              );
                            }
                          }}
                        >
                          {market.marketName}
                        </span>
                      ) : (
                        // eslint-disable-next-line jsx-a11y/no-distracting-elements
                        <marquee scrollamount="2" behavior="scroll" className="marquee-w-90"> <span className="marketnamemobile" title={market.marketName} onClick={() => { if (mktBets.length > 0) { this.props.showExpo(mktLineExpo, market.marketName); } }} style={{ fontWeight: "bold", cursor: "pointer", }}  > {market.marketName} </span> </marquee>)}
                      <a className="float-right">
                        {this.props.isRebateBonus && <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/rebatebonusicon.gif"} className="rebetbonusfancy"></img>}
                      </a>
                    </div>
                    <div>
                      {/* <a onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(market.marketId); }} className={this.props.pinnedEvents.indexOf(market.marketId) > -1 ? "add-pin-d select-pin-d mr-1 d-block pindesktophide" : "add-pin-d mr-1 d-block pindesktophide"} style={{ "cursor": "pointer" }} title="Add to Multi Markets"></a> */}
                      {mktBets.length > 0 && (
                        <Currency
                          classPropName={
                            "match-odds font-weight-bold d-inline-block"
                          }
                          amount={marketExpo}
                          showColor={true}
                        />
                      )}
                      <a
                        className="dhide float-right "
                        onClick={() => {
                          this.setState({ infoHide: false });
                        }}
                      >
                        <i className="fa fa-info-circle" aria-hidden="true"></i>
                      </a>
                      {this.state.mktMsg !== '' && (
                        <span className="wid250fancy">
                          <span className="fancymassage">
                            <i className="fa fa-envelope mr-1"></i>
                            {this.state.mktMsg}
                          </span>
                        </span>
                      )}
                      {!!this.props.msgMarket && this.state.mktMsg === '' && (
                        <span className="wid250fancy">
                          <span className="fancymassage">
                            <i className="fa fa-envelope mr-1"></i>
                            {this.props.msgMarket}
                          </span>
                        </span>
                      )}
                    </div>
                    {!this.state.infoHide && (
                      <div
                        className="mobile-show"
                        style={{
                          background: "#ccdddd",
                          padding: "5px",
                          borderRadius: "5px",
                          position: "absolute",
                          width: "94%",
                          zIndex: "1",
                          marginTop: "3px",
                        }}
                      >
                        <span className="d-block ">
                          {" "}
                          Max:
                          <span>
                            {(market.maxBet / currencyConversion).toFixed(2)}
                          </span>{" "}
                          | Max Profit:
                          <span>
                            {(
                              market.marketCondition.maxProfit /
                              currencyConversion
                            ).toFixed(2)}
                          </span>
                          <span
                            onClick={() => {
                              this.setState({ infoHide: true });
                            }}
                            style={{ marginRight: 5, cursor: "pointer" }}
                            className="float-right"
                          >
                            X
                          </span>
                        </span>
                      </div>
                    )}
                  </div>
                </td>
                <td className="w-16">
                  {!!runners &&
                    runners.map((runner_bk, i) => {
                      let is_active =
                        !!book && book !== {} && book.status === "OPEN";
                      {
                        /* let runnerAllow = this.state.market.provider === "BETHUBS" && i > 0 ? false : true */
                      }
                      let runnerAllow =
                        this.state.market.provider === "BETHUBS" &&
                          runner_bk.status === "SUSPENDED" &&
                          i > 0 && (runner_bk.lay.length === 0 && runner_bk.back.length === 0)
                          ? false
                          : true;

                      if (i > 0 && runner_bk.lay.length > 0 && runner_bk.back.length > 0) {
                        if (!runner_bk.lay[0].line || !runner_bk.back[0].line || (runner_bk.lay[0].line === 0 && runner_bk.back[0].line === 0)) {
                          runnerAllow = false
                        }
                      }
                      return (
                        <>
                          {runnerAllow &&
                            runner_bk.status !== "REMOVED" && (
                              <div
                                className={
                                  !!book &&
                                    book !== {} &&
                                    book.status !== "OPEN"
                                    ? "suspended-fancy"
                                    : !!book.sportingEvent &&
                                      !!book.sportingEvent === true
                                      ? "ballrunning-fancy"
                                      : ""
                                }
                              >
                                <div>
                                  <a
                                    id="btnLay"
                                    className="btn-lay border-bottom1"
                                    side="Lay"
                                    onClick={() => {
                                      !!book &&
                                        book !== {} &&
                                        book.status !== "CLOSED" &&
                                        book.status !== "INACTIVE" &&
                                        !!runner_bk &&
                                        !!runner_bk.lay[0] &&
                                        runner_bk.lay[0].price > 0 &&
                                        !market.betLock &&
                                        this.selectBid(
                                          market.marketName,
                                          runner_bk.lay[0].price,
                                          market.marketId,
                                          "lay",
                                          market.runners[0],
                                          runner_bk.lay[0].line
                                        );
                                    }}
                                    style={
                                      !!book &&
                                        book !== {} &&
                                        book.status !== "CLOSED" &&
                                        !!runner_bk &&
                                        !!runner_bk.lay[0] &&
                                        runner_bk.lay[0].has_blink
                                        ? {
                                          background: "gold",
                                          minHeight: "36px",
                                        }
                                        : { minHeight: "36px" }
                                    }
                                  >
                                    <div style={{ minHeight: "12px" }}>
                                      {!!book &&
                                        book !== {} &&
                                        book.status !== "CLOSED" &&
                                        book.status !== "INACTIVE" &&
                                        !!runner_bk &&
                                        !!runner_bk.lay[0] &&
                                        parseFloat(runner_bk.lay[0].price) !==
                                        0 &&
                                        is_active
                                        ? runner_bk.lay[0].line
                                        : ""}
                                    </div>
                                    {market.provider === "BETFAIR" &&
                                      market.bettingType === "LINE" ? (
                                      <span className="ask-price-small">
                                        <Volume
                                          key="l0"
                                          volume={
                                            !!runner_bk.lay[0] &&
                                              parseFloat(
                                                runner_bk.lay[0].price
                                              ) !== 0 &&
                                              is_active
                                              ? runner_bk.lay[0].size /
                                              currencyConversion
                                              : ""
                                          }
                                          multiplayFector={1}
                                        />
                                      </span>
                                    ) : (
                                      <span className="ask-price-small">
                                        {!!book &&
                                          book !== {} &&
                                          book.status !== "CLOSED" &&
                                          book.status !== "INACTIVE" &&
                                          !!runner_bk &&
                                          !!runner_bk.lay[0] &&
                                          parseFloat(runner_bk.lay[0].price) !==
                                          0 &&
                                          is_active
                                          ? runner_bk.lay[0].price
                                          : "00"}
                                      </span>
                                    )}
                                  </a>
                                </div>
                                <div>
                                  <a
                                    id="btnBack"
                                    className="btn-back border-bottom1"
                                    side="Back"
                                    onClick={() => {
                                      !!book &&
                                        book !== {} &&
                                        book.status !== "CLOSED" &&
                                        book.status !== "INACTIVE" &&
                                        !!runner_bk &&
                                        !!runner_bk.back[0] &&
                                        runner_bk.back[0].price > 0 &&
                                        !market.betLock &&
                                        this.selectBid(
                                          market.marketName,
                                          runner_bk.back[0].price,
                                          market.marketId,
                                          "back",
                                          market.runners[0],
                                          runner_bk.back[0].line
                                        );
                                    }}
                                    style={
                                      !!book &&
                                        book !== {} &&
                                        book.status !== "CLOSED" &&
                                        !!runner_bk &&
                                        !!runner_bk.back[0] &&
                                        runner_bk.back[0].has_blink
                                        ? {
                                          background: "gold",
                                          minHeight: "36px",
                                        }
                                        : { minHeight: "36px" }
                                    }
                                  >
                                    <div style={{ minHeight: "12px" }}>
                                      {!!book &&
                                        book !== {} &&
                                        book.status !== "CLOSED" &&
                                        book.status !== "INACTIVE" &&
                                        !!runner_bk &&
                                        !!runner_bk.back[0] &&
                                        parseFloat(runner_bk.back[0].price) !==
                                        0 &&
                                        is_active
                                        ? runner_bk.back[0].line
                                        : ""}
                                    </div>
                                    {market.provider === "BETFAIR" &&
                                      market.bettingType === "LINE" ? (
                                      <span className="bid-price-small">
                                        <Volume
                                          key="b0"
                                          volume={
                                            !!runner_bk.back[0] &&
                                              parseFloat(
                                                runner_bk.back[0].price
                                              ) !== 0 &&
                                              is_active
                                              ? runner_bk.back[0].size /
                                              currencyConversion
                                              : "0"
                                          }
                                          multiplayFector={1}
                                        />
                                      </span>
                                    ) : (
                                      <span className="bid-price-small">
                                        {!!book &&
                                          book !== {} &&
                                          book.status !== "CLOSED" &&
                                          book.status !== "INACTIVE" &&
                                          !!runner_bk &&
                                          !!runner_bk.back[0] &&
                                          parseFloat(runner_bk.back[0].price) !==
                                          0 &&
                                          is_active
                                          ? runner_bk.back[0].price
                                          : "00"}
                                      </span>
                                    )}
                                  </a>
                                </div>
                              </div>
                            )}
                        </>
                      );
                    })}
                </td>
                <td className="w-16 w-16-1 mobile-hide">
                  <div
                    className={
                      runnerCount > 1
                        ? "min-max-price min-max-price-center"
                        : "min-max-price"
                    }
                  >
                    <span className="d-block">
                      Max:
                      <span>
                        {market.maxBet / currencyConversion >= 1000
                          ? parseInt(
                            market.maxBet / currencyConversion / 1000
                          ) + "K"
                          : (market.maxBet / currencyConversion).toFixed(2)}
                      </span>
                    </span>
                    <span className="d-block">
                      MKT:
                      <span>
                        {market.marketCondition.maxProfit /
                          currencyConversion >=
                          1000
                          ? parseInt(
                            market.marketCondition.maxProfit /
                            currencyConversion /
                            1000
                          ) + "K"
                          : (
                            market.marketCondition.maxProfit /
                            currencyConversion
                          ).toFixed(2)}
                      </span>
                    </span>
                  </div>
                </td>
              </tr>
              {/* {!!this.props.msgMarket &&
                            <tr className="">
                                <td colSpan="3"><span className="fancymassage"><span className="mr-1 fancymass">Message</span> {this.props.msgMarket}</span></td>
                            </tr>
                        } */}
            </>
          )}
        {this.props.selected_market === market.marketId &&
          !book.sportingEvent &&
          book.status === "OPEN" && (
            <BetForm
              loadingBet={this.props.loadingBet}
              notify={(msg, type) => {
                this.props.notify(msg, type);
              }}
              eventMarket={market}
              selcted_bet_option={this.props.selcted_bet_option}
              updateExpo={(expo) => {
                this.updateExpo(expo);
              }}
              selectionId={this.state.selectionId}
              runner_name={this.state.runner_name}
              bid_at={this.state.bid_at}
              bid_line={this.state.bid_line}
              betForm={this.props.betForm}
              addBet={(data) => {
                this.addBetFn(data, market)
              }}
            />
          )}
      </>
    );
  }
}
